/**
 * 쿠키 헬퍼 유틸리티
 */

/**
 * 쿠키 설정
 * @param name 쿠키 이름
 * @param value 쿠키 값
 * @param days 만료일 (기본값: 365일)
 */
export function setCookie(name: string, value: string, days: number = 365): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

/**
 * 쿠키 가져오기
 * @param name 쿠키 이름
 * @returns 쿠키 값 또는 null
 */
export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * 쿠키 삭제
 * @param name 쿠키 이름
 */
export function deleteCookie(name: string): void {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
}

/**
 * 객체를 JSON 문자열로 변환하여 쿠키에 저장
 * @param name 쿠키 이름
 * @param value 저장할 객체
 * @param days 만료일 (기본값: 365일)
 */
export function setCookieObject(name: string, value: any, days: number = 365): void {
  try {
    const jsonString = JSON.stringify(value);
    setCookie(name, jsonString, days);
  } catch (error) {
    console.error('쿠키 저장 실패:', error);
  }
}

/**
 * 쿠키에서 JSON 문자열을 읽어 객체로 변환
 * @param name 쿠키 이름
 * @returns 파싱된 객체 또는 null
 */
export function getCookieObject<T = any>(name: string): T | null {
  try {
    const cookieValue = getCookie(name);
    if (!cookieValue) return null;
    return JSON.parse(cookieValue) as T;
  } catch (error) {
    console.error('쿠키 읽기 실패:', error);
    return null;
  }
}

